// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyD6qJ5VNE2n74CFYLoyp9sfU1M0d7YOorU",
    authDomain: "tailor4u-fdb85.firebaseapp.com",
    projectId: "tailor4u-fdb85",
    storageBucket: "tailor4u-fdb85.firebasestorage.app",
    messagingSenderId: "413675218011",
    appId: "1:413675218011:web:1222f8ce8a3de908d8cb7e",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const requestForToken = async () => {
    try {
        const currentToken = await getToken(messaging, { vapidKey: "BHFd0mWnixdIdw9HxT0vmeazg8uwKdUzcfn204i0bnoTAeUP788oZqOIxLfq7wWqyIgF1DgmMuEa9xym9ac7KSo" });
        if (currentToken) {
            console.log("FCM Token:", currentToken);
            // send token to backend here if needed
            return currentToken;
        } else {
            console.log("No registration token available.");
        }
    } catch (err) {
        console.error("Error retrieving token:", err);
    }
};

// export const onMessageListener = () =>
//     new Promise((resolve) => {
//         onMessage(messaging, (payload) => {
//             console.log('message recived');
            
//             resolve(payload);
//         });
//     });
